import { Directive, InjectOptions, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalComponent } from '@components/modal/modal.component';
import {
  NgbCalendar,
  NgbDate,
  NgbDateStruct,
  NgbInputDatepicker,
  NgbInputDatepickerConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';

const dateToNgbDateStruct = (v: Date): NgbDateStruct => ({
  day: v.getDate(),
  month: v.getMonth() + 1,
  year: v.getFullYear(),
});

@Directive()
export abstract class DatepickerBase {
  @Input() inputId: string;
  @Input() placeholder = $localize`rrrr-mm-dd`;
  @ViewChild('datepicker') datepicker: NgbInputDatepicker;
  maximumDate: NgbDateStruct | null;
  minimumDate: NgbDateStruct | null;

  constructor(
    protected readonly calendar: NgbCalendar,
    protected readonly viewContainerRef: ViewContainerRef,
    protected readonly ngbInputDatepickerConfig: NgbInputDatepickerConfig,
  ) {
    const checkParent = (el: HTMLElement): boolean => {
      if (el.className.includes('modal-body')) {
        return true;
      } else if (el.parentElement) {
        return checkParent(el.parentElement);
      }
    };

    const injectOptions: InjectOptions = {
      optional: true,
      skipSelf: true,
    };
    const appModal = this.viewContainerRef.injector.get(ModalComponent, null, injectOptions);
    const ngxModal = this.viewContainerRef.injector.get(BsModalRef, null, injectOptions);
    if (appModal || (ngxModal && ngxModal.id) || checkParent(viewContainerRef.element.nativeElement as HTMLElement)) {
      this.ngbInputDatepickerConfig.container = 'body';
    }
  }

  @Input() set minDate(v: string | Date | null) {
    this.minimumDate = v ? dateToNgbDateStruct(new Date(v)) : null;
  }

  @Input() set maxDate(v: string | Date | null) {
    this.maximumDate = v ? dateToNgbDateStruct(new Date(v)) : null;
  }

  isOutsideMonth = (date: NgbDate, currentMonth: number): boolean => date.month !== currentMonth;

  isWeekend = (date: NgbDate): boolean => this.calendar.getWeekday(date) >= 6;

  isWeekStart(date: NgbDate): boolean {
    return this.calendar.getWeekday(date) === 1;
  }

  isMonthStart(date: NgbDate): boolean {
    return date.day === 1;
  }

  abstract clear(): void;
}
